export enum FormTypeEnum {
  Undefined = 0,
  JoinForm = 1,
}
